export const maxTicketAllowed = 10;
export const adminAccounts = process.env.REACT_APP_ADMIN_ACCOUNTS.split(",");
